import {
  GetSnapshot,
  State as ComisionAnualidadState
} from "../../../reducers/comisionAnualidad";

/**
 * REPORTE GENERAL DE VENDEDORES — mapStateToProps
 * Pantalla: /reportes/reporte-general-vendedor
 *
 * Lee del slice Redux `comisionAnualidad` el resultado del endpoint
 * reporte-general-vendedor (snapshot paginado, loading y error).
 */
export interface ReporteGeneralVendedorStore extends GetSnapshot {
  userContext: any;
}

export const reporteGeneralVendedorStore: (
  state
) => ReporteGeneralVendedorStore = state => {
  const comisionAnualidad: ComisionAnualidadState = state.comisionAnualidad;

  return {
    snapshot: comisionAnualidad.snapshot,
    gettingSnapshot: comisionAnualidad.gettingSnapshot,
    gettingSnapshotError: comisionAnualidad.gettingSnapshotError,
    userContext: state.user.userContext
  };
};
